import { supabase } from "@/integrations/supabase/client";
import { z } from "zod";

// Comprehensive validation schema for contact form
export const contactFormSchema = z.object({
  name: z.string()
    .trim()
    .min(1, "Name is required")
    .max(100, "Name must be less than 100 characters")
    .regex(/^[a-zA-Z\s\-'\.]+$/, "Name contains invalid characters"),
  email: z.string()
    .trim()
    .min(1, "Email is required")
    .email("Invalid email address")
    .max(255, "Email must be less than 255 characters")
    .toLowerCase(),
  subject: z.string()
    .trim()
    .min(1, "Subject is required")
    .max(200, "Subject must be less than 200 characters"),
  message: z.string()
    .trim()
    .min(10, "Message must be at least 10 characters")
    .max(2000, "Message must be less than 2000 characters"),
});

export type ContactData = z.infer<typeof contactFormSchema>;

export async function submitContactMessage(contactData: ContactData) {
  // Validate input data
  const validatedData = contactFormSchema.parse(contactData);
  const { error } = await supabase
    .from('contact_messages')
    .insert({
      name: validatedData.name,
      email: validatedData.email,
      subject: validatedData.subject,
      message: validatedData.message,
    });

  if (error) {
    throw new Error(`Error submitting contact message: ${error.message}`);
  }

  return true;
}